import React, { useState } from "react";
import ImgixFluidImage from "../../newComponents/ImgixFluidImage";
import { useDisclosure } from "@chakra-ui/react";
import { ModalComponent } from "../../newComponents/modalComponent";

function SadaMultiPopUpImage({ block, last, }) {

    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedItem, setSelectedItem] = useState(0);

    const popUpHeadings = [ block.popUp1Heading, block.popUp2Heading, block.popUp3Heading, block.popUp4Heading, block.popUp5Heading, block.popUp6Heading, ];
    const popUpRichTexts = [ block.popUp1RichText, block.popUp2RichText, block.popUp3RichText, block.popUp4RichText, block.popUp5RichText, block.popUp6RichText, ];

    const image = block.image[0];

    const finalImage = image ?
        <figure className={`${last ? "" : "mb-7 lg:mb-5"}`}>
        <ImgixFluidImage attribution={image.attribution} image={image} ar={image.width / image.height} focalPoint={image.focalPoint} />
        {image.caption && <figcaption className="text-sm text-gray-600 px-1 pt-2" dangerouslySetInnerHTML={{ __html: image.caption }}/>}
        </figure>
        :
        <div>Image not found...</div>

    return (
        <section>
            <div className="shell">
                {block.imageLink ? <a href={block.imageLink}>{finalImage}</a> : finalImage}
                <button aria-label="Universal digital access  pop up" style={{position: "absolute", left: "29%", width: "15%", height: "22%", top: "12%", display: "block"}} onClick={() => { onOpen(); setSelectedItem(0); }}></button>
                <button aria-label="Human capital  pop up" style={{position: "absolute", right: "31%", width: "15%", height: "22%", top: "12%", display: "block"}} onClick={() => { onOpen(); setSelectedItem(1); }}></button>
                <button aria-label="Innovative business pop up" style={{position: "absolute", left: "22%", top: "43%", width: "15%", height: "22%", display: "block"}} onClick={() => { onOpen(); setSelectedItem(2); }}></button>
                <button aria-label="Government support pop up" style={{position: "absolute", right: "23%", width: "15%", height: "22%", top: "43%", display: "block"}} onClick={() => { onOpen(); setSelectedItem(3); }}></button>
                <button aria-label="Constructing ecosystems pop up" style={{position: "absolute", left: "42%", width: "15%", height: "22%", top: "auto", bottom: "16%", display: "block"}} onClick={() => { onOpen(); setSelectedItem(4); }}></button>
                <button aria-label="Digital economic opportunities pop up" style={{position: "absolute", left: "42%", width: "15%", height: "25%", top: "34%", display: "block"}} onClick={() => { onOpen(); setSelectedItem(5); }}></button>
            </div>
            <ModalComponent isOpen={isOpen} onClose={onClose} title={popUpHeadings[selectedItem]}>
                <div className="prose max-w-none mb-4 body-content-rich-text-bullets" dangerouslySetInnerHTML={{ __html: popUpRichTexts[selectedItem], }}/>
            </ModalComponent>
        </section>
    );
}

export default SadaMultiPopUpImage;
